export const projectPermissionKeys = ['overview', 'schedule', 'inventory', 'templates', 'references', 'matrix', 'products', 'settings']

const rolePermissionDefaults = {
  owner: projectPermissionKeys,
  operator: ['overview', 'schedule', 'inventory', 'templates', 'references', 'matrix', 'products'],
  editor: ['overview', 'inventory', 'templates', 'references', 'products'],
  viewer: ['overview', 'schedule', 'inventory'],
}

export function getDefaultPermissions(role) {
  return [...(rolePermissionDefaults[role] || rolePermissionDefaults.viewer)]
}

export function getMemberProjectIds(member, projects) {
  if (!member) return []
  if (member.role === 'owner') return projects.map(project => project.id)
  return [...new Set(Array.isArray(member.projectIds) ? member.projectIds : member.projectId ? [member.projectId] : [])]
}

export function getMemberPermissions(member, projectId) {
  if (!member || !projectId) return []
  if (member.role === 'owner') return projectPermissionKeys
  const configured = member.permissionsByProject?.[projectId]
  return [...new Set((Array.isArray(configured) ? configured : getDefaultPermissions(member.role)).filter(permission => projectPermissionKeys.includes(permission)))]
}

export function canAccessProject(member, projectId, projects) {
  return getMemberProjectIds(member, projects).includes(projectId)
}

export function canAccessPermission(member, projectId, permission) {
  return getMemberPermissions(member, projectId).includes(permission)
}
